import axiosInstance from './axiosInstance';

export async function getAllPayments(page = 1, limit = 10) {
  const response = await axiosInstance.get('/payments/get-all-payments.php', {
    params: { page, limit },
  });
  return response.data;
}

export async function createPayment(paymentData) {
  const response = await axiosInstance.post('/payments/create-payment.php', paymentData);
  return response.data;
}

export async function markPaymentPaid(id) {
  const response = await axiosInstance.post('/payments/mark-payment-paid.php', { id_payment: id });
  return response.data;
}

export async function getPaymentAdminDetail(id) {
  const response = await axiosInstance.get(`/payments/get-payment-admin-detail.php?id=${id}`);
  return response.data;
}

export async function updatePaymentStatus(id, payStatus) {
  const response = await axiosInstance.post('/payments/update-payment-status.php', {
    id_payment: id,
    pay_status: payStatus,
  });
  return response.data;
}



export async function searchPayments({ q = '', from = '', to = '', status = '', page = 1, limit = 10 }) {
  const response = await axiosInstance.get('/payments/search-payments.php', {
    params: { q, from, to, status, page, limit },
  });
  return response.data;
}